export default __webpack_public_path__ + "e4b385b143b67c520ba27dfb4d30849c.png";